import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

const icons = {
  CurrencyExchangeIcon
};

const bersettlement = {
  id: 'bersettlement',
  type: 'group',
  children: [
    {
      id: 'bersettlement',
      title: 'BER Settlement',
      type: 'item',
      url: '/BER-Settlement',
      icon: icons.CurrencyExchangeIcon,
    }
  ]
};

export default bersettlement;
